import { useEffect, useState } from 'react'
import type { AdaptiveCardChoice } from '../../store/slices/adaptiveCardSlice' 

const useValues = (instanceId?: string): Record<string, string | number | Array<string> | Array<number> | AdaptiveCardChoice | boolean> => {
  const [current, setCurrent] = useState<Record<string, string | number | Array<string> | Array<number> | AdaptiveCardChoice | boolean>>({})

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_values', ((e: CustomEvent) => handleChange(e)) as EventListener)
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_values'))

    return () => {
      document.removeEventListener('retorik_values', ((e: CustomEvent) => handleChange(e)) as EventListener)
    }
  }, [])

  return current
}

export default useValues
